import { SharedLocale, type SharedLocalizedString } from "./SharedLocale.js";

export const sharedLocaleLangMap = {
	[SharedLocale.cs]: "cs",
	[SharedLocale.en]: "en",
	[SharedLocale.pl]: "pl",
	[SharedLocale.sk]: "sk",
} satisfies SharedLocalizedString;
